import { Box, Text } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';
import { DataList } from '@tiendanube/components';

function OrderTotalInProgressRow(): JSX.Element {
  const { t } = useTranslation(Domain.ORDERS, {
    keyPrefix: 'orderSummaryCard.tableAmounts',
  });

  return (
    <DataList.Row id="total-in-progress" grayed>
      <DataList.Cell width={70}>
        <Box display="flex" flexDirection="row" gap="0-5">
          <Text fontWeight="bold" color="neutral-textHigh">
            {t('total')}
          </Text>
        </Box>
      </DataList.Cell>
      <DataList.Cell width={30} alignRight>
        <Text textAlign="right" fontWeight="bold" color="neutral-textHigh">
          {t('merchantChargesInProgress')}
        </Text>
      </DataList.Cell>
    </DataList.Row>
  );
}
export default OrderTotalInProgressRow;
